module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1028-b983ac491564081803237edcc934f565.png";